<template>
  <Badge size="medium" :dot="true" :variant="color" :label="status" />
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { ApplicationBundleStatus } from '@tallo/applications';
import { Badge, BadgeVariant } from '@tallo/design-system';

const props = defineProps<{ status: ApplicationBundleStatus }>();
const colorMap = new Map<ApplicationBundleStatus, BadgeVariant>([
  [ApplicationBundleStatus.SENT, 'blue'],
  [ApplicationBundleStatus.IN_PROGRESS, 'yellow'],
  [ApplicationBundleStatus.SUBMITTED, 'green'],
  [ApplicationBundleStatus.UPDATE_REQUESTED, 'violet'],
  [ApplicationBundleStatus.ACCEPTED, 'green'],
  [ApplicationBundleStatus.DECLINED, 'red'],
]);

const color = computed(() => colorMap.get(props.status));
</script>
